export function lastIndexOf(array: any[], key: string, keyToCompare: string) {
  for (let i = array.length - 1; i >= 0; i--) {
    if (array[i][keyToCompare] === key) {
      return i;
    }
  }

  return -1;
}
